import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { withTrackedSceneView } from '@portal/common/services/google-analytics';

import GuestLayout from './GuestLayout';

const AnonymousRoute: FC = () => (
    <GuestLayout>
        <Outlet />
    </GuestLayout>
);

export default withTrackedSceneView(AnonymousRoute);
